<nav>
	<div class="d-flex flex-wrap py-2">
		@for (breadcrumb of breadcrumbs; track breadcrumb; let isLast = $last; let isFirst = $first) {
			<div [class.active]="isLast" class="d-flex">
				@if (!isLast) {
					<a
						[class.first]="isFirst"
						class="text-smaller app-link-dark"
						[target]="target"
						[routerLink]="[breadcrumb.routerLink]"
						[queryParams]="breadcrumb.queryParams">
						<ng-container *ngTemplateOutlet="breadcrumbItem; context: { breadcrumb }"> </ng-container>
					</a>
				}
				@if (isLast) {
					<h1 class="text-smaller fw-normal" style="margin-top: 1px">
						<ng-container *ngTemplateOutlet="breadcrumbItem; context: { breadcrumb }"> </ng-container>
					</h1>
				}
				@if (!isLast) {
					<img class="px-1" style="height: 18px; width: 18px" [src]="getDivider()" alt="breadcrumb divider" />
				}
			</div>
		}
		@if (!breadcrumbs?.length) {
			<div>&nbsp;</div>
		}
	</div>
</nav>

<ng-template #breadcrumbItem let-breadcrumb="breadcrumb">
	@if (breadcrumb?.key) {
		<span [class.has-text]="breadcrumb?.text">
			{{ breadcrumb.key | translate }}
		</span>
	}
	@if (breadcrumb?.text) {
		{{ breadcrumb?.text }}
	}
</ng-template>
